<template>
  <div class="employeeRoster page_fnncsum">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
             <el-input size="small" clearable placeholder="请输入项目名称" v-model="listQuery.custname" @keyup.enter.native="getList()"></el-input>
            <!-- <el-input size="small" v-if="listQuery.looktype == 1" clearable placeholder="请输入身份证号码" v-model="listQuery.idcard" @keyup.enter.native="getList()"></el-input> -->
            <span style="margin-left:10px">记账日期:</span>
            <el-date-picker
                v-model="listQuery.bookingRealMonth"
                type="month"
                 :picker-options="pickerSearchOptions"
                :clearable="false"
                 value-format="yyyy-MM">
            </el-date-picker>
            <span style="margin-left:10px">归属日期:</span>
            <el-date-picker
                v-model="listQuery.belongMonth"
                type="month"
                 :picker-options="pickerSearchOptions"
                clearable
                value-format="yyyy-MM">
            </el-date-picker>
            <el-button type="success" plain size="small" @click="searchEnterFun" style="margin-left:5px">搜索</el-button>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button type="success" size="small" plain @click="dropDownScreen">
          筛选
        </el-button>
        <el-button type="danger" v-if="isCanHandle && (this.closeAccountType == '1')" plain size="small" @click="closeHandle">关账</el-button>
        <el-button type="primary" plain size="small" @click="exportHandle" :loading="exportLoading" v-if="isCanHandle && (tableData.length>0&&!isNull(tableData))">导出</el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select v-model="listQuery.strSrvCent" slot="prepend" placeholder="请选择" filterable @change="serviceChange">
              <el-option v-for="(item,index) in serviceList" :key="index" :label="item.StrSrvCent" :value="item.StrSrvCent"></el-option>
            </el-select>
          </div>
          <!-- <div class="formScreenInput">
            <div>项目名称</div>
            <el-input size="small" clearable placeholder="请输入项目名称" v-model="listQuery.custname" @keyup.enter.native="getList()"></el-input>
          </div> -->
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="resetHandle">清空</button>
          <button class="search" @click="searchEnterFun">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
        <div class="page_breads">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>财务总计</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 管理员可看的内容 -->
      <adminSum v-if="loginRoletype =='adminuser'||loginRoletype =='adminusers'" ref="adminSum" :toChildrenData="listQuery" @func="getMsgData"></adminSum>
      <!-- 客服可看的内容 -->
      <customerSum v-else ref="adminSum" :toChildrenData="listQuery" @func="getMsgData"></customerSum>
    </div>
    <!-- 关账弹窗 -->
    <el-dialog
        title="关账"
        :visible.sync="dialogVisible"
        width="35%">
        <el-date-picker
            v-model="cfgvalue"
            type="month"
            :picker-options="pickerOptions"
            value-format="yyyy-MM"
            placeholder="请选择关账月份">
        </el-date-picker>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="closeSureHandle">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "../../common";
import { parseTime } from '../../utils' //格式化时间格式
import adminSum from "./../../components/adminFnncsum.vue";
import customerSum from "./../../components/cusFnncsum.vue";
export default {
   components: {
     adminSum,
     customerSum
    },
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight:0,
      tableData: [],
      //列表参数
      listQuery:{
        pagecount: 10,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        strSrvCent:'',//服务中心
        looktype:2 //1 人员总计详情  2 项目总计
      },
      //切换tab
      activeName: 'first',
      //导出参数
      exportQuery:{
        pagecount: 1000000,
        currpage: 1,
        custname: "",
        tableid: "XzFinance",
        username: "",
        idcard:'',
        bookingRealMonth:'',
        belongMonth:'',
        looktype:2 //1 人员总计详情  2 项目总计
      },
      //导出按钮加载状态
      exportLoading:false,
      //关账弹出框
      dialogVisible:false,
      //关账日期查询参数
      closeQuery:{
        currpage:1,
        perpage:10
      },
      //关账日期
      closeDate:'',
      //修改关账日期
      cfgvalue:'',
      //禁用日期范围
      pickerSearchOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions:{},
      //关账人员类型 1能关账
      closeAccountType:'',
      //人员角色
      loginRoletype:'',
      //下拉服务中心列表
      serviceList: [],
      isActive: 0,
      //下拉筛选
      showDropScreen: -1,
      // 按钮权限参数
      butQuery:{
        roletype:'',
        page:'employee-fnnclst'
      },
      // 是否有权限操作按钮
      isCanHandle:false
    }; 
  },
  created() {
    this.butQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
    this.closeAccountType = localStorage.closeAccountType
    this.loginRoletype = localStorage.loginRoletype
    this.listQuery.bookingRealMonth = parseTime(new Date(), '{y}-{m}')
    this.listQuery.belongMonth = parseTime(new Date(), '{y}-{m}')
    this.calHeight()
    this.getServiceList()
  },
  methods: {
    getMsgData(val){
      // console.log('ss',val)
      this.tableData = val
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
      // console.log('height',this.tableHeight) 
    },
     //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1
      }
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
          // console.log('按钮',res)
          if(res.status == 'ok'){
            let powerVal  = res.msg[0].Buttons
            if(powerVal == 'search'){
              // 只能查看
              this.isCanHandle = false
            }else if(powerVal == 'update'){
              // 特殊处理 只能更改客服
              this.isCanHandle = false
            }else if(powerVal == 'operation'){
              // 可操作
              this.isCanHandle = true
            }
          }else{
            this.isCanHandle = false
          }
        })
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstlist().then(res => {
        // console.log("getServeList", res);
        let dataList = []
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname })
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    serviceChange() {
       this.$refs.adminSum.getList(this.listQuery)
      if(this.listQuery.looktype == 2){
        this.$refs.adminSum.getObjList()
      }
      // if(this.listQuery.looktype == 3){
      //   this.getContrastList()
      // }
    },
    //清空
    resetHandle() {
      this.listQuery.pagecount= 10
      this.listQuery.currpage=1
      // this.listQuery.custname=""
      // this.listQuery.tableid= "XzFinance"
      // this.listQuery.username= ""
      // this.listQuery.idcard=''
      // this.listQuery.belongMonth=''
      this.listQuery.strSrvCent=''//服务中心
      // this.listQuery.looktype=2 //1 人员总计详情  2 项目总计
    },
    //导出
    exportHandle(){
      this.exportQuery.tableid = this.listQuery.tableid
       this.exportQuery.custname = this.listQuery.custname
       this.exportQuery.idcard = this.listQuery.idcard
        this.exportQuery.username = this.listQuery.username
       this.exportQuery.bookingRealMonth = this.listQuery.bookingRealMonth
       this.exportQuery.belongMonth = this.listQuery.belongMonth
       this.exportQuery.looktype = this.listQuery.looktype
       if(this.isNull(this.listQuery.bookingRealMonth)){
           this.$message({
            showClose: true,
            message: "请选择记账日期",
            type: "warning"
          });
          return false
       }else{
          this.exportLoading = true
          xz.reportfinanceCurrDataTable(this.exportQuery).then(res => {
              // console.log('process', res)
              if(res.status == 'ok'){
              this.$router.push({
                  path: "/employee-fnnchis",
                  query: {
                  showPage: 1,
                  isActive: 1,
                  custname: res.msg,
                  //qStstus=1时查看最后一条导出记录
                  qStstus: 1
                  }
              })
              }else{
                this.$message({
                    message: "导出错误，请稍后再试",
                    type: "error"
                });
              }
              this.exportLoading = false
          })
       }
    },
    //关账
    closeHandle(){
        this.cfgvalue = ''
        this.dialogVisible = true
        //查询关账日期
        xz.getaccountDate(this.closeQuery).then(res =>{
          // console.log('sdf',res)
            if(res.msg&&res.msg.length>0){
              this.closeDate = res.msg[0].Cfgvalue
              let closeDates = res.msg[0].Cfgvalue
              //关账人员
              if(this.closeAccountType != '1'){
                this.pickerOptions = {
                  disabledDate(time) {
                    return time.getTime() < new Date(closeDates).getTime()+30*24*60*60*1000
                  }
                }
              }
            }
        })
    },
    //确定关账
    closeSureHandle(){
      if(this.isNull(this.cfgvalue)){
        this.$message({
            showClose: true,
            message: "请选择关账月份",
            type: "warning"
          });
          return false
      }else{
         xz.closeaccount(this.cfgvalue).then(res =>{
            if(res.status == 'ok'){
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success"
              });
              this.dialogVisible =false
            }else{
              this.$message({
                message: "关账出错",
                type: "error"
              });
            }
        })
      }
    },
    //搜索
    searchEnterFun(){
      this.$refs.adminSum.getList(this.listQuery);
      if(this.listQuery.looktype == 2){
        this.$refs.adminSum.getObjList()
      }
      this.showDropScreen == -1
      // if(this.listQuery.looktype == 3){
      //   this.getContrastList()
      // }
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right{
margin-right: 16px;
}
.crumbs {
    margin-top: 20px;
    margin-bottom: 1px;
    background-color: #fff;
}
.page_breads{
  margin-top: 20px;
}

</style>
<style>
.page_fnncsum .formScreenInput .el-input__inner{
  width: 210px;
}
.page_fnncsum .el-tabs__header{
    margin: 0;
}
.page_fnncsum .screenInput .el-input{
    width: 180px;
}
.page_fnncsum .screenInput .el-date-editor.el-input{
    width: 130px;
}
.page_fnncsum .el-date-editor .el-input__inner{
height: 32px;
line-height: 32px;
}
.page_fnncsum .el-date-editor .el-input__icon{
    line-height: 33px;
}
.page_fnncsum .el-select .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.page_fnncsum .el-select .el-input__icon{
  line-height: 32px;
}
</style>